/* eslint-disable react/prop-types */
import BaseFooter from '@layout/Footer/BaseFooter';
import AboutUs from '@comp/AboutUs/AboutUs';
import styled from '@emotion/styled';
import { getImage } from '@utils/imageHelper';
import SEO from '@seo/index';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import Typography from 'aquilla/core/atoms/Typography';
import { Fonts, Spacings } from '@styles/index';

const Layout = styled.div`
  width: 1136px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  grid-column-gap: ${Spacings.SPACING_4B};
  grid-row-gap: ${Spacings.SPACING_4B};
  @media (max-width: 70.95em) {
    width: 100%;
    padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_4B};
    grid-template-columns: repeat(24, 1fr);
    grid-column-gap: ${Spacings.SPACING_2B};
  }
  @media (max-width: 70.95em) {
    padding: ${Spacings.SPACING_0B};
    grid-column-gap: ${Spacings.SPACING_2B};
    grid-row-gap: ${Spacings.SPACING_2B};
  }
`;

const LogoContainer = styled.div`
  width: 1136px;
  margin: auto;
  z-index: 1;
  height: ${Spacings.SPACING_14B};
  @media (max-width: 70.95em) {
    width: 100%;
  }
`;

const Logo = styled.img`
  position: absolute;
  top: ${Spacings.SPACING_6B};
  @media (max-width: 70.95em) {
    width: 115px;
    height: ${Spacings.SPACING_18};
    left: ${Spacings.SPACING_4B};
  }
`;

const Video = styled.video`
  width: 100%;
  object-fit: cover;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
`;

const Header = styled.header`
  position: relative;
  height: 100vh;
`;
const HeaderContent = styled.div`
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  position: absolute;
  bottom: 40px;
`;

const Headline = styled(Typography)`
  font-size: ${Fonts.EXTRA_LARGE};
  color: var(--color-i-white);
  width: 705px;
  z-index: 1;
  margin-top: ${Spacings.SPACING_4B};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};

  @media (max-width: 70.95em) {
    font-size: ${Fonts.H3};
    line-height: ${Spacings.SPACING_9B};
    text-align: center;
    width: auto;
    color: var(--color-i-pitch-black);
  }
  @media (max-width: 70.95em) {
    color: var(--color-i-white);
    font-size: ${Fonts.H3};
    line-height: ${Fonts.HEADER_LINE_HEIGHT};
  }
`;

const Tags = styled(Typography)`
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_6B};
  background: var(--color-i-black-6);
  backdrop-filter: blur(80px);
  border-radius: ${Spacings.SPACING_2B};
  color: var(--color-i-white);
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.LARGE};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  letter-spacing: 2px;
  @media (max-width: 70.95em) {
    font-size: ${Fonts.ULTRA_SMALL};
    letter-spacing: 1.2px;
    text-align: center;
    padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
    backdrop-filter: blur(44px);
  }
`;

const StyledBaseFooter = styled(BaseFooter)`
  @media (max-width: 70.95em) {
    margin-top: 0;
  }
`;

const title = "About Unacademy – India's Largest Learning Platform";
const url = 'https://unacademy.com/about';
const description =
  "Learn about Unacademy, India's largest online learning platform with 50M+ learners and 1000+ top educators, on a mission to democratise quality education.";

const AboutUsLanding = () => {
  return (
    <>
      <SEO
        title={title}
        description={description}
        url={url}
        openGraph={{ title, description, url }}
      />
      <AboutUs />
    </>
  );
};

const PageLayout = ({ children }) => (
  <>
    <Header>
      <Video loop muted autoPlay playsInline>
        <source
          src="https://quark.uacdn.net/acquisition/AboutUsHeader--compressed.webm"
          type="video/webm"
        />
        <source
          src="https://quark.uacdn.net/acquisition/AboutUsHeader--compressed.mp4"
          type="video/mp4"
        />
      </Video>
      <LogoContainer>
        <Logo src={getImage('un_white_logo.svg')} alt="logo" />
      </LogoContainer>
      <HeaderContent>
        <Tags>EDUCATE • ENABLE • EMPOWER</Tags>
        <Headline variant="h1">
          Unacademy is India’s largest online learning app
        </Headline>
      </HeaderContent>
    </Header>

    <Layout>{children}</Layout>

    <StyledBaseFooter display />
  </>
);

AboutUsLanding.Layout = PageLayout;

AboutUsLanding.pageInfo = {
  name: 'Unacademy About',
  isMWebSupported: true,
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true,
    disableDarkMode: true
  }
};

export default AboutUsLanding;
AboutUsLanding.Wrapper = PageReduxProvider;
